import type { RecommendedProduct } from '@noths/polaris-dev-ts-types';
import type { SerializedError } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { logger } from 'src/utils/serverLogger';
import { requestRecommendedProducts } from './thunks';

type RichRelevancePlacement = {
  placementStrategy?: string;
  placementTitle?: string;
  products: RecommendedProduct[] | null;
};

export type RichRelevanceState = {
  errors: SerializedError[] | null;
  placements: {
    [key: string]: RichRelevancePlacement;
  };
};

export const initialState: RichRelevanceState = {
  errors: null,
  placements: {},
};

export const { actions, reducer } = createSlice({
  name: 'richRelevance',
  initialState,
  reducers: {
    noDataForPlacement: (state, action) => {
      state.placements[action.payload] = {
        products: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestRecommendedProducts.pending, (state, action) => {
        const placementType = action.meta.arg.placement_name;

        state.placements[placementType] = { products: null };
      })
      .addCase(requestRecommendedProducts.fulfilled, (state, { payload }) => {
        if (payload && payload.placementType) {
          state.placements[payload.placementType] = {
            placementTitle: payload.placementTitle,
            placementStrategy: payload.placementStrategy,
            products: payload.products,
          };
        }
      })
      .addCase(requestRecommendedProducts.rejected, (state, action) => {
        if (action.payload?.error) {
          logger.error('Error requesting similar products', action.payload.error);

          state.errors = state.errors
            ? state.errors.concat([action.payload.error])
            : [action.payload.error];
        }

        if (action.payload?.placementType) {
          state.placements[action.payload.placementType] = {
            products: [],
          };
        }
      });
  },
});
